import React, { FC, useEffect, useState } from 'react';
import { Menu, Spin } from 'antd';
import type { MenuProps } from 'antd';
import { useAppDispatch, useAppSelector } from 'common/hooks';
import { HistoryItem, HistoryNote } from 'entities/History/components';
import { eventHistoryMenuItems } from 'entities/History/History.const';
import { getFullHistory } from 'entities/History/History.helper';
import { EEventHistoryMenuKey } from 'entities/History/History.enum';
import { IPatient } from 'entities/Patient/Patient.models';

interface IComponentProps {
  eventId?: number;
  patient: IPatient | null;
}

export const History: FC<IComponentProps> = ({ eventId, patient }) => {
  const { noteList, noteListLoading, historyList, historyListLoading } = useAppSelector((state) => ({
    noteList: state.noteList.data,
    noteListLoading: state.noteList.loading,
    historyList: state.historyList.data,
    historyListLoading: state.historyList.loading,
  }));
  const { noteList: noteListDispatch, historyList: historyListDispatch } = useAppDispatch();
  const [menuKey, setMenuKey] = useState<EEventHistoryMenuKey>(EEventHistoryMenuKey.Notes);

  useEffect(() => {
    const fetch = async () => {
      if (eventId && patient) {
        await noteListDispatch.getNotes({ patientId: patient.id });
        await historyListDispatch.getHistory(eventId);
      }
    };

    fetch();
  }, [eventId, patient]);

  const onMenuKeyClick: MenuProps['onClick'] = (e) => {
    setMenuKey(e.key as EEventHistoryMenuKey);
  };

  const renderContent = () => {
    switch (menuKey) {
      case EEventHistoryMenuKey.EventHistory: {
        return historyList.map((item) => <HistoryItem key={item.id} item={item} />);
      }
      case EEventHistoryMenuKey.All: {
        const fullHistory = getFullHistory(historyList, noteList);

        return fullHistory?.map((item) => {
          // @ts-ignore
          return item.note ? <HistoryNote key={item.id} note={item} /> : <HistoryItem key={item.id} item={item} />;
        });
      }
      default: {
        return noteList.map((note) => <HistoryNote key={note.id} note={note} />);
      }
    }
  };

  return (
    <div className="history">
      <div className="mb-5 ff-medium fs-lg history__title">Review history</div>

      <div className="mb-5">
        <Menu mode="horizontal" items={eventHistoryMenuItems} selectedKeys={[menuKey]} onClick={onMenuKeyClick} />
      </div>

      <Spin spinning={noteListLoading || historyListLoading}>
        <div className="history__content">{renderContent()}</div>
      </Spin>
    </div>
  );
};
